import { Grid, lighten, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const MainBlock = styled(Grid)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-end",
  width: "100%",
  minWidth: "700px",
  marginBottom: "15px !important",
  paddingRight: "5px",

  "& > div": {
    borderBottom: `1px solid ${lighten(theme.palette.text.disabled, 0.7)}`,
  },
}));

export const HeaderRow = styled(Grid)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  flexWrap: "nowrap",
  fontWeight: "bold",
  "& > div": {
    borderRight: `1px solid ${lighten(theme.palette.text.disabled, 0.7)}`,
    "&:last-of-type": {
      borderRight: "none",
    },
  },
}));

export const StyledTableCell = styled(Grid, {
  shouldForwardProp: (prop) => prop !== "align" && prop !== "minWidth" && prop !== "width" && prop !== "flex",
})<{ align?: "left" | "center" | "right"; width?: number; minWidth?: number; flex?: number }>(
  ({ theme }) => ({
    flex: 1,
    padding: "5px",
    minWidth: "100px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  }),
  ({ flex, theme }) => ({
    ...(!!flex && {
      flex,
    }),
  }),
  ({ minWidth, theme }) => ({
    ...(!!minWidth && {
      minWidth: `${minWidth}px`,
    }),
  }),
  ({ width, theme }) => ({
    ...(!!width && {
      width: `${width}px`,
      minWidth: `${width}px`,
      maxWidth: `${width}px`,
    }),
  }),
  ({ align, theme }) => ({
    ...(!!align && {
      justifyContent: align,
    }),
  })
);

export const TableBodyRow = styled(Grid)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  flexWrap: "nowrap",
  "& > div": {
    borderRight: `1px solid ${lighten(theme.palette.text.disabled, 0.7)}`,
    "&:last-of-type": {
      borderRight: "none",
    },
  },
}));

export const Amounts = styled(Typography)({
  overflow: "hidden",
  textOverflow: "ellipsis",
  textAlign: "end",
});
